import React, { Component } from 'react';
import './index.scss';

import {observer,inject} from 'mobx-react';

@inject("summaryDataStore")
@observer
class ProgressLine extends Component {

    constructor(props){
        super(props);
        this.state = {
            status: 'orange',
            statusText: 'เต็มประสิทธิภาพ',
        }
    }

    componentDidMount() {
        const { percentValue } = this.props;
        this.changStatus(percentValue);
    }

    componentWillReceiveProps(nextProps) {
        const { percentValue } = nextProps;
        this.changStatus(percentValue);
    }

    changStatus(percentValue) {
        const { idSelected, idMaxPackage } = this.props.summaryDataStore;
        let status, statusText, isMaxPackage;
        isMaxPackage = (idSelected == idMaxPackage)
        if(percentValue >= 0 && percentValue <= 70) {
            status = 'green';
            statusText = 'เหมาะสม';
        } else if ( (percentValue > 71 && percentValue <= 90) || isMaxPackage) {
            status = 'orange';
            statusText = 'เต็มประสิทธิภาพ';
        } else if (percentValue > 91) {
            status = 'red';
            statusText = 'ควรเพิ่มขนาดโซลาร์เซลล์';
        } else {
            status = 'red';
        }
        this.setState({status:status,statusText:statusText});
    }

    render() {
        const { percentValue } = this.props;
        const { status, statusText } = this.state;
        return (
            <div className='ProgressLine'>
                <h1 className={status}> {statusText} </h1>
                <div className='bgProgress'>
                    <div className={'percent '+status} style={{transform: 'scaleX('+(percentValue/80)+')'}}> </div>
                </div>
            </div>
        );
    }
}

export default ProgressLine;


// WEBPACK FOOTER //
// ./src/components/accessories/progressLine.js